import { useEffect, useState } from 'react';

export const ratingApi = '/api/reviews/v1/reviews';

export type AsyncData<D> =
  | { status: 'Loading' }
  | { status: 'Error'; error: Error }
  | { status: 'Success'; data: D };

export type Review = {
  id: string;
  stars: number;
  title: string;
  text: string;
  language: string;
  isVerified: boolean;
  consumer: {
    id: string;
    displayName: string;
  };
  createdAt: string;
};

export type ReviewData = {
  reviews: Review[];
};

export type ReviewSummary = {
  numberOfReviews: number;
  starsImageUrl: string;
  starsString: string;
  starsValue: number;
  trustScore: number;
};

export const handleFetch = async <D>(
  promise: Promise<Response>,
  setState: (state: AsyncData<D>) => void,
) => {
  const res = await promise;
  if (!res.ok) {
    setState({
      status: 'Error',
      error: new Error(String(await res.text())),
    });
    return;
  }

  const body: D = await res.json();

  setState({
    status: 'Success',
    data: body,
  });
};

export const useTrustPilotSummary = (): AsyncData<ReviewSummary> => {
  const [state, setState] = useState<AsyncData<ReviewSummary>>({
    status: 'Loading',
  });

  useEffect(() => {
    const promise = fetch(`${ratingApi}/summary`);

    handleFetch(promise, setState);
  }, []);

  return state;
};

export const useTrustPilotReviews = (): AsyncData<ReviewData> => {
  const [state, setState] = useState<AsyncData<ReviewData>>({
    status: 'Loading',
  });

  useEffect(() => {
    const promise = fetch(ratingApi);

    handleFetch(promise, setState);
  }, []);
  return state;
};
